import { render, staticRenderFns } from "./RoiResults.vue?vue&type=template&id=6ce81624&"
import script from "./RoiResults.vue?vue&type=script&lang=js&"
export * from "./RoiResults.vue?vue&type=script&lang=js&"
import style0 from "./RoiResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/kevin/code/websites/dataself-calc/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
import { VSparkline } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VLayout,VSheet,VSparkline})
